// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uzGS","controls":"styles_controls__9IqoL","charLimit":"styles_charLimit__8zcIQ","input":"styles_input__3vQRA","send":"styles_send__3S7vZ"};